// extracted by mini-css-extract-plugin
module.exports = {"item":"a2JWe","name":"xRxkU","price":"LYzWk","selectors":"sajlD","radio":"rBrN2","quantity-btn":"e1Cw8","plus":"CUPY4","minus":"kPSmm"};